<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
        <form  novalidate #loginForm="ngForm" (submit)="loginForm.valid && submitLogin()">
          <div class="text-center">
            <img class="header-logo" src="../../../assets/images/urbansofa_logo_white.png" alt="logo.png">
          </div>
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <h3 class="text-center">{{'auth.singin.title'|translate}}</h3>
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.signin.username'|translate}}</label>
                <input type="text" name="userName" #userName="ngModel" [(ngModel)]="login.username" class="form-control" required>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="userName.invalid && userName.dirty && userName.errors?.required">{{'errors.required'|translate}}</div>
                </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.signin.password'|translate}}</label>
                <input type="password" name="password" #password="ngModel" class="form-control" [(ngModel)]="login.password" required minlength="6">
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="password.invalid && password.dirty && password.errors?.required">{{'errors.required'|translate}}</div>
                <div class="messages text-danger" *ngIf="password?.errors?.minlength">{{'validators.password.length.min'|translate}}</div>
              </div>
              <div class="d-flex justify-content-between m-t-25 text-start">
                <div class="checkbox-fade fade-in-primary">
                  <label>
                    <input type="checkbox" value="" [(ngModel)]="login.rememberMe" name="rememberMe" >
                    <span class="cr"><i class="cr-icon fa fa-check txt-primary"></i></span>
                    <span class="text-inverse">{{'auth.signin.remember_me'|translate}}</span>
                  </label>
                </div>
                <div class="forgot-phone text-end float-right">
                  <a [routerLink]="['/forgot-password']" class="text-end f-w-600"> {{'auth.link.forgot_password'|translate}}</a>
                </div>
              </div>
              <div class="row m-t-30">
                <div class="col-md-12">
                  <button [disabled]="!loginForm.valid || isSubmitting" [ngClass]="{'btn-disabled': !loginForm.valid, 'disabled': !loginForm.valid}" type="submit" class="btn btn-primary btn-md btn-block text-center m-b-20 ripple light">{{'auth.signin.button'|translate}}</button>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-12">
                  <a href="https://www.urbansofa.nl/">
                    <span class="text-inverse text-start m-b-0">https://www.urbansofa.nl/</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
